import { FC } from 'react';
import { Typography } from 'antd';

import { SettingsCard } from './SettingsCard';

import { useAppSelector, useTranslate } from 'hooks';

import { ReactComponent as StarIcon } from 'assets/icons/star.svg';

import Utils from 'utils/utils';

import s from './index.module.scss';

export const SettingsPersonalBonusCard: FC = () => {
	const user = useAppSelector((state) => state.user.entity);

	const { personalBonusText, yourPersonalBonusText, readMoreBonusText } = useTranslate([
		'personalBonusText',
		'yourPersonalBonusText',
		'readMoreBonusText',
	]);

	return (
		<SettingsCard
			title={
				<div className={s.loyaltyTitle}>
					{personalBonusText} <StarIcon />
				</div>
			}
			className="loyalty"
		>
			<div className={s.loyaltyRow}>
				<Typography.Text className={s.text}>{yourPersonalBonusText}</Typography.Text>
				<div className={s.text}>
					{user.personalInterests.map((item, i) => {
						const isGrown = +item.rate >= 0;
						return (
							<Typography.Text key={item.id} type="danger">
								{isGrown ? '+' : ''}
								{Number(item.rate)}%{i < user.personalInterests.length - 1 && ', '}
							</Typography.Text>
						);
					})}

					{!user.category.isDefault && !user.category.isLoyalty && (
						<Typography.Text type="danger">
							{user.personalInterests.length > 0 ? ', ' : ''}+{user.category.interestRate}%
						</Typography.Text>
					)}
				</div>
			</div>

			<Typography.Text type="secondary" className={s.readMore}>
				<a
					href={Utils.getLinkLanguage(
						'help-category/welcome-bonus',
						'lt/duk-category/premija-investavimo-pradziai',
					)}
					className={s.link}
					target="_blank"
					rel="noreferrer"
				>
					{readMoreBonusText}
				</a>
			</Typography.Text>
		</SettingsCard>
	);
};
